var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TranslationDisplay',{staticClass:"story-title mb-4",attrs:{"tag":"h4","translation":_vm.lift.title,"html":""}})}
var staticRenderFns = []

export { render, staticRenderFns }